<template>
  <div class="full-screen">
    <span>我的位置：{{ currentPosition.address }}</span>
    <img 
		src="@/assets/public/map_point.png" 
		@click="clickCurrentPoint" 
	/>
    <el-button class="btn" @click="fullScreen">退出全屏</el-button>
  </div>
</template>

<script>
export default {
  props: {
	currentPosition: { // 当前定位
		type: Object,
		default: () => ({})
	},
  },
  data () {
	return {

	}
  },
  mounted () {

  },
  methods: {
	clickCurrentPoint() {
		this.$emit('myPoint')
	},
	fullScreen() {
		this.$emit('fullScreen')
	}
  }
}
</script>

<style lang="scss" scoped>
.full-screen {
	padding: 10px 40px;
	box-shadow: 10px 10px 5px blue;
	display: flex;
	align-items: center;
	span {
		font-size: 14px;
		color: #333;
	}
	img {
		width: 22px;
		cursor: pointer;
		margin-left: 10px;
	}
	.btn {
		margin-left: 10px;
	}
}
</style>
